import type { ArticleSuppLang } from '~/types/common/article'

/** 推广卡片类型 */
type ResolvableValue = 'summary' | 'summary_large_image' | 'app' | 'player'

/** 静态配置 */
export const useConfigStatic = () => {
  /** 站点基础信息 */
  const configSite = {
    /** 站点标题 */
    TITLE: 'Crystal Network',
    /** Logo图地址 */
    LOGO: '/img/logo/cnl-480x248.png',
    /** 显示/隐藏顶栏背景色的滚动条阈值 */
    SHOW_BG_THRESHOLD: 200,
    /** 显示/隐藏工具箱的滚动条阈值 */
    SHOW_TOOLBOX_THRESHOLD: 200,
    /** ❗文章支持的语言，直接影响搜索功能、文章数量、内容等等 */
    ARTICLE_SUPP_LANGS: ['zh_hans'] satisfies ArticleSuppLang[],
    /** 文章回退默认语言 */
    ARTICLE_DEFAULT_LNAG: 'zh_hans' satisfies ArticleSuppLang,
  } as const

  /** 站点OG配置 */
  const configOG = {
    /** og图片 */
    IMG: '/img/bg/home-1.avif',
    /**
     * 推特卡片分享样式
     * summary_large_image → 最佳默认选择（大图吸引点击）
     * summary → 小图，适合简洁内容
     * app → 仅用于推广 App
     * player → 用于视频/音频播放
     */
    TWITTER_CARD: 'summary_large_image' satisfies ResolvableValue,
  } as const

  /** 本地储存键名 */
  const configStorageKey = {
    FINGERPRINT: 'fingerprint',
    LANGUAGE: 'language',
    HEADER_FINGERPRINT: 'X-Fingerprint',
  } as const

  return { configSite, configOG, configStorageKey }
}
